<template>
  <div class="wrapper">
    <van-cell-group>
      <!-- <van-cell title="昵称" is-link :value="nikeName" @click="gotoModifyNikeName"/> -->
      <van-cell title="手机号" is-link :value="phoneNum|phoneFormat" @click="gotoModifyNum"/>
      <van-cell title="真实姓名" :value="userName" @click="gotoAuth"/>
      <van-cell title="身份证号" :value="userCardId|cardFormat" @click="gotoAuth"/>
      <van-cell title="关联账号" :value="AssociatedAccount" @click="gotoAssociatedAccount"/>
      <!-- <van-cell title="邮箱" is-link :value="email" @click="gotoModifyEmail"/> -->
    </van-cell-group>

    <div class="cell-divider"></div>
    <!-- <van-cell-group>
      <van-cell title="认证级别">
        <template slot="default">
          <span class="custom-value">{{authLevel}}</span>
          <van-tag color="#f2826a" plain>升级认证</van-tag>
        </template>
      </van-cell>
    </van-cell-group>-->
    <van-cell-group>
      <van-cell title="修改密码" is-link @click="gotoModifyPwd" v-show="identLevel!=1"/>
    </van-cell-group>
    <van-cell-group>
      <!-- <van-cell title="重置密码" is-link @click="gotoresetPwd"/> -->
    </van-cell-group>
  </div>
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup } from "vant";
import { Tag } from "vant";
import checkAJB from "../../utils/checkAlipayJSBridge.js";
import { mapGetters } from "vuex";
import { searchPerLegalDetail } from "@/api/user";
Vue.use(Tag);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
  data() {
    return {
      nikeName: "一只大鲨鱼",
      userName: "去实名>",
      userCardId: "去实名>",
      email: "test@sina.com",
      authLevel: "初级认证",
      AssociatedAccount: "暂无关联账号",
      sessionInfo: {},
      loginFlag: "1",
      identLevel: "1"
    };
  },
  async created() {
    let res = await this.$store.dispatch("user/getUserInfo");
    if (this.sessionId === "") {
      await this.checkAJB.userLogin();
      let res = await this.$store.dispatch("user/getUserInfo");
    }
    console.log(res, "hahhh");
    this.sessionInfo = JSON.parse(this.userInfo);
    this.loginFlag = this.sessionInfo.loginFlag;
    this.identLevel = this.sessionInfo.identLevel;
    this.phoneNum = this.sessionInfo.userName;
    if (this.loginFlag == "2") {
      this.userName = this.sessionInfo.name;
      this.userCardId = this.sessionInfo.idCard;
    }
    if (this.phoneNum == "") {
      this.$store.commit("user/SET_PHONENUM", this.sessionInfo.userName);
    }
    this.requestAssociated();
  },
  computed: {
    ...mapGetters(["sessionId", "userInfo", "phoneNum"])
  },
  filters:{
			cardFormat: (value) => {
        if(value=="去实名>"){
          return value
        }else{
          return value.replace(/^(.{4})(?:\d+)(.{4})$/, "$1********$2")
        }
				
      },
      phoneFormat: (value) => {
        return value.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2")
      }
  },
  methods: {
    // 请求用户关联账号信息
    async requestAssociated() {
      let associated = await searchPerLegalDetail({
        headers: { sgasession: this.sessionId }
      });
      if (associated.respCode == "000000000") {
        if (associated.respData != null) {
          console.log(associated.respData);
        }
      }
    },
    gotoModifyNikeName() {
      this.$router.push({
        name: "modifyNikeName",
        params: {
          nikeName: this.nikeName
        }
      });
    },
    gotoModifyNum() {
      if (this.loginFlag == "1" && this.identLevel == "1") {
        return;
      }
      this.$router.push({
        name: "modifyPhoneNum",
        params: {
          phoneNum: this.phoneNum
        }
      });
    },
    gotoModifyEmail() {
      this.$router.push({
        name: "modifyEmail",
        params: {
          email: this.email
        }
      });
    },
    gotoModifyPwd() {
      // if (this.loginFlag == "1") {
      //   checkAJB.userVerify();
      // } else {
      //   this.$router.push({
      //     name: "modifyPwd"
      //   });
      // }
      this.$router.push({
        name: "modifyPwd"
      });
    },
    gotoresetPwd() {
      this.$router.push({
        name: "resetPwd"
      });
    },
    gotoAssociatedAccount() {
      if (this.AssociatedAccount != "暂无关联账号") {
        this.$router.push({
          name: "AssociatedAccount"
        });
      }
    },
    gotoAuth() {
      if (this.loginFlag == "2" && this.identLevel == "2") {
        return;
      }
      if (this.identLevel == "1") {
        checkAJB.userAuth();
      } else if (this.identLevel == "2") {
        checkAJB.userVerify().then(() => {
          window.location.reload();
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background: #f1f2f3;
  .custom-value {
    margin-right: 8px;
  }
}
</style>